import React, { Component }        from 'react';
import moment                      from 'moment';
import { connect }                 from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import { Link }                    from 'react-router-dom';
import renderField                 from '../../../../container/renderField';
import renderFieldSelec            from '../../../../container/renderFieldSelect';
import renderMultiselect           from '../../../../container/renderMultiSelect';
import renderDatePicker            from '../../../../container/renderDatePicker';
import validate                    from '../../../../service/validade_missoes';
import { SetCadastroAtividades }   from '../../../../actions/atividadesAction';
import { SetError }                from '../../../../actions/notificacaoAction';
import { getDisciplinaPerfil }     from '../../../../actions/batalhaAction';
import SenhaForm                   from '../senha/desafios_senha_form';
import BombaForm                   from '../bomba/desafios_bomba_form';
import QuizForm                    from '../quiz/desafios_quiz_form';
import { ActionModal,
         GetListaMenuTopo,
         GetListaSubMenuTopo}      from '../../../../actions/scopoAction';

class Missoes_Cadastro extends Component {

    constructor(props){
        super(props);
        this.state = {
                       redirect        : false,
                       redirectQuestao : false,
                       data            : moment(),
                       habilitar       : true,
                       use_id          : this.props.session.id,
                       textButton      : 'Avançar',
                       titulo          : "Cadastrar desafio",
                       form            : true,
                       formAdicionar   : false
                      }                    
    }

    componentWillMount(){
        this.props.getDisciplinaPerfil(this.props.session.id, this.props.session.perfil,null).then((response) => {
            if(!response.payload.data.length){
               alert("Você não está vinculado a nenhuma Unidade Curricular até o momento.")
               this.setState({redirect:true})   
            }
        }).catch((error)=>{
            this.props.SetError(500);
        });
        
        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:this.props.menu.desafios.nomeModulo,link:this.props.menu.desafios.home},
            {action:false,nome:'Adicionar desafio'}
           ]);
           this.props.GetListaSubMenuTopo([]);
    }

    handleSubmit(e){

        var acaoForm = { usu_id             : this.props.session.id,
                          ati_data_inicio    : moment(this.state.data).format('YYYY-MM-DD'),
                          ati_data_fim       : moment(this.state.dataFim).format('YYYY-MM-DD'),
                          ati_titulo         : e.ati_titulo,
                          disciplina_turma   : e.disciplinas.map((elem,i)=>{return elem.id;}),
                          ati_tipo           : e.ati_tipo,
                          ati_qtd_tentativas : parseInt(e.ati_qtd_ten),
                          ati_id             : 0
                         }

       this.setState({textButton:'Enviando...'});
       this.props.SetCadastroAtividades(acaoForm).then((response)=>{  
          switch (e.ati_tipo) {
            case this.props.menu.desafios.jogo.tipo1:            
                this.setState({
                                form          : false,
                                titulo        : "Adicionar Questão",
                                formAdicionar : <SenhaForm pal_id={response.payload.data}/>
                             });                
            break;

            case this.props.menu.desafios.jogo.tipo2:            
                this.setState({
                                form          : false,
                                titulo        : "Adicionar Questão",
                                formAdicionar : <BombaForm pal_id={response.payload.data}/>
                             });                            
            break;

            case  this.props.menu.desafios.jogo.tipo3:
                this.setState({
                                form          : false,
                                titulo        : "Adicionar Questão",
                                formAdicionar : <QuizForm que_id={response.payload.data}/>
                             });                
            break;          
        
            default:
            break;
        }
       }).catch((error)=>{
          this.props.SetError(500);
       });

    }

    dataInicioChange(e){
      this.setState({data:moment(e, 'YYYY-MM-DD', true),habilitar:false})
    }
    
    dataFimChange(e){
      this.setState({dataFim:moment(e, 'YYYY-MM-DD', true)})
    }

    render() {
        
        // if(this.state.redirect){return(<Redirect to={this.props.menu.desafios.home}/>);}
           
        const {handleSubmit}  = this.props;
        const listQdtTen      = [1, 2, 3].map((ten, ar)  => <option key={ar} value={ten}>{ten}</option>);
        const listaTipoMissao = [
                                 {
                                  tipo: this.props.menu.desafios.jogo.jogo2,
                                  value:this.props.menu.desafios.jogo.tipo2
                                 }, 
                                 {
                                  tipo:this.props.menu.desafios.jogo.jogo3,
                                  value:this.props.menu.desafios.jogo.tipo3
                                 },
                                   {
                                    tipo:this.props.menu.desafios.jogo.jogo1,
                                    value:this.props.menu.desafios.jogo.tipo1
                                   }
                                 ];
        const listTipoMissao  = listaTipoMissao.map((elem, i)  => <option key={i} value={elem.value}>{elem.tipo}</option>);
        const disciplinas     = this.props.disciplinas.map((elem,i)=>{ return {disciplinas:elem.tur_nome+' - '+elem.dis_nome+' - '+elem.cur_nome,id:elem.dis_pro_cod_disciplina + '#' + elem.tur_id}});
        const formMissao      =    <div className="container-bg">
                                    <div className="panel panel-default">
                                        <div className="panel-body">
                                            <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                                                <Field name="ati_titulo" label="Título*" component={renderField} type="text" placeholder="Título" />
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <Field name="ati_tipo" label="Selecione o tipo de desafio*" component={renderFieldSelec} option={listTipoMissao}/>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Field name="ati_qtd_ten" label="Quantidade de Tentativa*" component={renderFieldSelec} option={listQdtTen}/>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <Field label="Data Ínicio*" minData={moment()} component={renderDatePicker} name="ati_data_ini" onChange={this.dataInicioChange.bind(this)}/>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Field label="Data Fim*" minData={this.state.data} component={renderDatePicker} habilitar={this.state.habilitar} name="ati_data_fim" onChange={this.dataFimChange.bind(this)}/>
                                                    </div>
                                                </div>
                                                <Field name="disciplinas" label="Unidade Curricular/Turma*" value='id' textField='disciplinas' data={disciplinas} component={renderMultiselect}/>
                                                <Link  to={this.props.menu.desafios.home} className="btn btn-sm btn-primary pull-left">Voltar</Link>
                                                <button type="submit" className="btn btn-primary btn-sm pull-right">{this.state.textButton}</button>
                                            </form>
                                        </div>
                                    </div>
                                    </div>;



        return (
            <div>
                  {this.state.form ? formMissao : this.state.formAdicionar }

            </div>
        );
    }
}
const afterSubmit = (result, dispatch) => dispatch(reset('missoes_form'));

function mapStateToProps(state){

    return {
             session     : state.auth.session,
             disciplinas : state.batalhaReducer.allDisciplina,
             menu      : state.configReducer.menu
            };
  }

export default reduxForm({
  form                     : 'missoes_form',
  destroyOnUnmount         : true,
  forceUnregisterOnUnmount : true,
  onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps, { getDisciplinaPerfil,
                              SetCadastroAtividades,
                              ActionModal,
                              SetError,
                              GetListaMenuTopo,
                              GetListaSubMenuTopo
                            })(Missoes_Cadastro));




// WEBPACK FOOTER //
// ./src/components/professor/desafios/form/desafios_cadastro.js